import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { saveAs } from 'file-saver';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import LeadsStatusesFetchContext from '@/modules/leads_statuses/contexts/LeadsStatusesFetchContext';
import Button from '@/modules/common/components/Button';
import ButtonGroup from '@/modules/common/components/ButtonGroup';
import DownloadMenu from '@/modules/common/components/DownloadMenu';
import ContentBodyTop from '@/modules/common/components/ContentBodyTop';
import { withFetch } from '~/hocs/fetch';
import { withRouter } from '~/hocs/router';
import { base64toBlob } from '~/common';
import { actionSetDownloadingLeadsStatusesFetch } from '@/modules/application/actions/downloading';

const Top = (props) => {
    // noinspection JSCheckFunctionSignatures
    const leadsStatusesFetchContext = useContext(LeadsStatusesFetchContext);
    const data = leadsStatusesFetchContext.data;
    const ids = leadsStatusesFetchContext.ids;

    const fetch = (format) => {
        props.setFetching(true);
        return props.fetch.post(
            `/api/leads_statuses/fetch/download/${format}/?${props.router.urlSearchParams.toString()}`,
            {ids: ids},
        ).then(({ok, data}) => {
            if (ok) {
                const blob = base64toBlob(data.blob);
                // noinspection JSUnresolvedVariable
                saveAs(blob, data.file_name);
            }
        }).finally(() => {
            props.setFetching(false);
        });
    };

    const handleClickDownload = (popupState, format) => () => {
        popupState.close();
        fetch(format);
    };

    return (
        <ContentBodyTop
            left={<>
                {(data.results.length > 0)
                    ? <DownloadMenu fetching={props.fetching} onClickDownload={handleClickDownload}/>
                    : null
                }
            </>}
            right={
                <form id="form-filter">
                    <ButtonGroup>
                        <Button onClick={props.onClickResetFetch}>Сбросить выгрузку</Button>
                    </ButtonGroup>
                </form>
            }
        />
    );
};

Top.propTypes = {
    onClickResetFetch: PropTypes.func.isRequired,
};

let Component = Top;
Component = withRouter(Component);
Component = withFetch(Component);

export default connect(
    (state) => ({
        ids: state.leads_statuses_fetch.ids,
        fetching: state.downloading.leadsStatusesFetch,
    }),
    (dispatch) => ({
        setFetching: bindActionCreators(actionSetDownloadingLeadsStatusesFetch, dispatch),
    })
)(Component);
